import React, { useState, useEffect } from "react";
import Nav from "./Nav";
import axios from "axios";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withRouter } from "react-router-dom";
import { CgPlayListRemove } from "react-icons/cg";
import { MdPlaylistAdd } from "react-icons/md";
import { ImUser, ImUserPlus } from "react-icons/im";


function Users() {
    const [filteredUserList, setFilteredUserList] = useState([]);
    const [open, setOpen] = useState(false);
    const [userCurrentId, setUserCurrentId] = useState("");
    const [emptyQueueText, setEmptyQueueText] = useState("");

    useEffect(() => {
        const userListUrl = process.env.REACT_APP_BASEURL + process.env.REACT_APP_USER_LIST_URL;
        axios.get(userListUrl)
            .then((response) => {
                if (response.data.filter(filterByRole).length === 0) {
                    setEmptyQueueText("Empty");
                    setFilteredUserList([]);
                }
                else {
                    setEmptyQueueText("");
                    setFilteredUserList(response.data.filter(filterByRole));
                }
            })
            .catch(err => {
                console.log(err);
            })
    }, [setFilteredUserList, setEmptyQueueText]);

    const deleteUser = () => {
        axios.get(`${process.env.REACT_APP_BASEURL + process.env.REACT_APP_DELETE_USER_URL}` + userCurrentId)
            .then((response) => {
                setOpen(false);
                if (response.data.data.filter(filterByRole).length === 0) {
                    setEmptyQueueText("Empty");
                    setFilteredUserList([]);
                }
                else {
                    setEmptyQueueText("");
                    setFilteredUserList(response.data.data.filter(filterByRole));
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const handleClickOpen = (event) => {
        event.preventDefault();
        setUserCurrentId(event.target.id);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const filterByRole = (user) => {
        if (user.role === "Service Staff") {
            return user;
        }
    }

    return (
        <div className="admin-body">
            <Nav
                headerText="ADMIN"
                nav1="Service Setup"
                nav2="Delete Service"
                nav3="Add User"
                nav4="View Users"
                path1="/setupService"
                path2="/removeService"
                path3="/addUser"
                path4="/users"
                icon1={<MdPlaylistAdd />}
                icon2={<CgPlayListRemove />}
                icon3={<ImUserPlus />}
                icon4={<ImUser />}
            />
            <div className="remove-service-body">
                <div className="service-setup-container">
                    <div className="header-container">
                        <h2>USERS</h2>
                    </div>
                    <hr />
                    <div className="data-container">
                        {filteredUserList.length !== 0 ?
                            <table className="data-inner-container">
                                <tr>
                                    <th className="table-head">Name</th>
                                    <th className="table-head">Username</th>
                                    <th className="table-head">Email</th>
                                </tr>
                                {filteredUserList.map((user) => {
                                    return (
                                        <tr key={user.userId}>
                                            <td className="table-data">{user.name}</td>
                                            <td className="table-data">{user.username}</td>
                                            <td className="table-data">{user.email}</td>
                                            <td id="delete-btn">
                                                <button
                                                    id={user.userId}
                                                    type="submit"
                                                    className="new-service-btn"
                                                    name="submit"
                                                    onClick={handleClickOpen}>
                                                    Delete
                                                </button>

                                            </td>
                                        </tr>
                                    )
                                })}
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">Delete User</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this user
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={deleteUser} color="primary">Yes</Button>
                                        <Button onClick={handleClose} color="primary" autoFocus>No</Button>
                                    </DialogActions>
                                </Dialog>
                            </table>
                            : <h1>{emptyQueueText}</h1>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withRouter(Users);